import React from "react";
import "./banners.scss";
import { useTranslation } from "react-i18next";
import CusButton from "../../mui/custom_button/CusButton";
import imgGirlBonus from "./bonus-girl.webp";
import WelcomeBanner from "./welcome_banner/WelcomeBanner.jsx";
import useBanners from "../../../hooks/other/useBanners.js";
import ShowContainer from "../../mui/ShowContainer.jsx";
import useDynamicImages from "../../../hooks/useDynamicImages.js";
import { useAppSelector } from "../../../store/index.ts";
import CarouselOrTag from "../../mui/CarouselOrTag.jsx";
import { Link } from "react-router-dom";
import useGetLink from "../../../hooks/other/useGetLink.js";

export default function Banners() {
  const { t } = useTranslation();
  const banners = useBanners();

  const isExtraSmall = useAppSelector((state) => state.deviceSize.isExtraSmall);
  const { imgBonusMain } = useDynamicImages();

  const linkPromo = useGetLink("/promotions");

  const defaultBanners = !banners.length;
  const emptyDesktop = !banners.filter((el) => el.fileUrl).length && !defaultBanners;
  const isTwoBannersClass = defaultBanners || (banners.length && imgBonusMain) ? "two" : "one";

  return (
    <ShowContainer
      condition={isExtraSmall || !emptyDesktop}
      plug={<article className="banners"></article>}>
      <CarouselOrTag
        tag={"article"}
        className={`banners ${isTwoBannersClass}`}
        isCarousel={defaultBanners && isExtraSmall}
        spaceBetween={12}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 8000, disableOnInteraction: false, pauseOnMouseEnter: true }}>
        <WelcomeBanner defaultBanners={defaultBanners} />

        {defaultBanners ? (
          <section className="banners__bonus">
            <div className="banners__bonus__info">
              <h2>{t("All bonuses for you:")}</h2>
              <p>{t("All bonuses in one place: welcome, no deposit and much more")}</p>
              <CusButton
                to={"/promotions"}
                text={"Go"}
                color="blue"
                aria-label={t("Go to promotions page")}
                hiddenText={"to promotions"}
              />
            </div>
            <img src={imgGirlBonus} alt={t("img banner girl")} />
            <div className="bottom-blur" />
          </section>
        ) : undefined}

        {imgBonusMain && !defaultBanners ? (
          <Link to={linkPromo}>
            <section className="banners__bonus__custom">
              <img src={imgBonusMain} alt={t("default bonus banner")} />
            </section>
          </Link>
        ) : undefined}
      </CarouselOrTag>
    </ShowContainer>
  );
}
